export const ShiftScheduleVI = {
    "timeEngineSider": {
        "shiftRoster": "Bảng phân ca tháng" ,
        "title" : "Bảng phân công lao động từ ",
        "to" : " đến "
    },
    "timeEngineTitle": {
        "STT": "TT",
        "ID": "Mã NV",
        "fullName": "Họ và Tên",
        "department": "Phòng ban",
        "jobPosition": "Vị trí",
        "totalPoints": "Công tổng",
        "points": "Số công",
        "hour": "Tổng giờ",
        "standardPoints": "Công chuẩn",
        "late": "Đi muộn",
        "minute": "Số phút",
        "monetaryFine": "Tiền phạt",
        "finePoints": "Công phạt",
        "soon": "Về sớm",
        "forget": "Quên chốt",
        "noReason": "Nghỉ không lý do",
        "leave": "Nghỉ",
        "onLeave": "Nghỉ phép",
        "first": "Đầu kỳ",
        "used": "Đã dùng",
        "last": "Cuối kỳ",
        "moreHour": "Số giờ thêm",
        "compensatoryLeave": "Nghỉ bù",
        "mainPoints": "Công chính",
        "workMore": "Làm thêm",
        "shiftPoints": "Công ca",
        "holidayPoints": "Công lễ",
        "missionPoints": "Công công tác",
        "nightWorkHour": "Giờ làm đêm",
        "holidayHour": "Giờ ngày lễ",
        "dayOffHour": "Giờ ngày nghỉ",
        "shiftDayHour": "Giờ ngày ca",
        "hourCount": "Số giờ",
        "shiftCount": "Số công",
        "shiftMore": "Tăng ca",
        "eatPoints": "Công ăn",
        "nightHour": "Giờ đêm",
        "totalAdd": "Số giờ thêm"
    },
    "timeEngineDetail": {
        "noRecord" : "Không tìm thấy kết quả nào",
        "shiftWork": "Ca làm việc:",
        "shiftWorkName": "Tên ca:",
        "shiftWorkCode": "Mã ca:",
        "shiftWorkTime":"Thời gian vào ra:",
        "timeNotExist": "Không có",
        "date": "Ngày",
        "contextMenu": {
            "reCountPoints": "Tính toán lại công, phạt",
            "exportFile": "Xuất file tính công",
            "updateFingerprint": "Cập nhật chốt vân tay"
        },
        MANUAL: "Thủ công",
        GPS: "Di động",
        APP: "Đơn từ",
        MACHINE: "Máy",
        recallSuccess: "Tính toán lại công thành công",
        header: "Bảng chấm công tháng"
    },
    "timeSheetHeader": {
        "header": "Bảng chấm công tháng"
    }
}